import Api from '@teko/api';
import { getEnv } from '../../helpers';

export const magentoApi = new Api(getEnv('BASE_EXTRA_SERVICE_URL') as string);

export const serverApi = new Api('/api');

export const searchApi = new Api(
  typeof window === 'undefined' && (getEnv('INTERNAL_SEARCH_URL') as string)
    ? (getEnv('INTERNAL_SEARCH_URL') as string)
    : (getEnv('BASE_SEARCH_URL') as string),
);

export const wordpressPVApi = new Api(getEnv('BASE_WORDPRESS_URL') as string);

export const ppmApi = new Api(getEnv('BASE_PPM_URL') as string);

export const publicSettingApi = new Api(
  getEnv('BASE_PUBLIC_SETTING_API') as string,
);

export const wordpressApi = new Api(getEnv('BASE_WORDPRESS_API') as string);

export const consumerBffApi = new Api(getEnv('BASE_COV_URL') as string);
